/**
 * @module RubleCircle
 */

import Component from '../../base/Component';
import '../../../images/sprite/fb.svg';
import '../../../images/sprite/vk.svg';
import '../../../images/sprite/gplus.svg';
import '../../../images/sprite/ok.svg';
import './styles.css';

/**
 * Название компонента.
 */
export default class RubleCircle extends Component {
    static className = 'ruble-circle';
}
